<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">عرض البيانات</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <!--begin::Body-->
    <div class="card-body">
      <div v-if="dataRow" class="row">
        <div v-if="dataRow.path" class="col-12 col-sm-6 text-center mb-4">
          <img :src="MEDIA_URL+dataRow.path" class="img-thumbnail" style="max-width: 250px;" alt="">
        </div>
        <div v-if="dataRow.pathEn" class="col-12 col-sm-6 text-center mb-4">
          <img :src="MEDIA_URL+dataRow.pathEn" class="img-thumbnail" style="max-width: 250px;" alt="">
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">عند الضغط على الصورة:</label>
          <div v-if="!actionType">لا يوجد إجراء</div>
          <div v-if="actionType == 'link'">يقوم بفتح صفحة ويب</div>
          <div v-if="actionType == 'page'">يقوم بفتح صفحة داخل التطبيق</div>
        </div>
        <div v-if="actionType == 'link'" class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">رابط صفحة الويب:</label>
          <div>{{ action }}</div>
        </div>
        <div v-if="actionType == 'page'" class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">اختر الصفحة:</label>
          <div v-if="!action">لم يحدد</div>
          <div v-if="action == 'manage_property_services'">يقوم بفتح إدارة الاملاك</div>
          <div v-if="action == 'advertising'">يقوم بفتح إضافة إعلان</div>
          <div v-if="action == 'maintenance'">يقوم بفتح طلب صيانة</div>
          <div v-if="action == 'property_request'">يقوم بفتح طلب عقار</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">حالة الإعلان:</label>
          <div>{{ (isActive)? 'نشط' : 'غير نشط' }}</div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BannersView',
  props: {
    dataRow: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      image: null,
      imageEn: null,
      actionType: null,
      action: null,
      isActive: true,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },
  created(){
    if(this.dataRow){
      this.actionType = this.dataRow.actionType;
      this.action = this.dataRow.action;
      this.isActive = this.dataRow.isActive;
    }
  }
}
</script>
